import { useState, useEffect } from "react";

import {
  packingTypeService,
  materialTypeService,
  measurementTypeService,
  currencyService,
  taxTypeService,
} from "_services";

const useFetchCommonTypes = () => {
  const [taxTypes, setTaxTypes] = useState([]);
  const [packingTypes, setPackingTypes] = useState([]);
  const [materialTypes, setMaterialTypes] = useState([]);
  const [currencyTypes, setCurrencyTypes] = useState([]);
  const [measurementTypes, setMeasurementTypes] = useState([]);
  const [selectedMaterial, setSelectedMaterial] = useState(null);

  const [boms, setBoms] = useState([]);

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const getAllTaxTypes = await taxTypeService.getAll();

        setTaxTypes(getAllTaxTypes.content);

        const finshedProductsResponse =
          await materialTypeService.getAllFinished();

        setBoms(finshedProductsResponse.content);

        const packingResponse = await packingTypeService.getAll();
        setPackingTypes(packingResponse.content);

        const materialResponse = await materialTypeService.getSuggestion();
        setMaterialTypes(materialResponse.content);

        const currencyResponse = await currencyService.getSuggestion();
        setCurrencyTypes(currencyResponse.content);

        const measurementResponse =
          await measurementTypeService.getSuggestion();
        setMeasurementTypes(measurementResponse.content);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const setMaterialsForBomSelected = (bomId) => {
    const bomFound = boms?.find((bom) => bom.id == bomId);

    setMaterialTypes(bomFound?.materials ?? []);
  };

  const getMaterialSelected = (materialId) => {
    const materialFound = materialTypes?.find(
      (material) => material.id === materialId
    );
    //setSelectedMaterial(materialFound);
    return materialFound;
  };
  const onMaterialSelected = (materialId) => {
    const materialFound = materialTypes?.find(
      (material) => material.id === materialId
    );

    setSelectedMaterial(materialFound);
    setPackingTypes([materialFound?.packingType]);
    setMeasurementTypes(materialFound?.measurementTypes);
  };

  return {
    taxTypes,
    boms,
    packingTypes,
    materialTypes,
    setMaterialsForBomSelected,
    getMaterialSelected,
    onMaterialSelected,
    selectedMaterial,
    currencyTypes,
    measurementTypes,
    error,
    loading,
  };
};

export default useFetchCommonTypes;
